export default {
  CARD_VIEW: {
    icon: 'view_agenda',
    value: 'Card View',
  },
  TABLE_VIEW: {
    icon: 'grid_on',
    value: 'Table View',
  },
};
